import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { routes } from 'router';
import {
  resetAuthStore,
  resetCart,
  resetLeisurePurchaseStore,
  resetPersistedCart,
  resetStore,
  resetTravelPurchaseStore
} from 'store';

export const useUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isLoggedIn = !isEmpty(Cookies.get('user'));

  const currentUser = useMemo(() => {
    if (!isEmpty(Cookies.get('user'))) {
      return JSON.parse(Cookies.get('user'));
    }
    return null;
  }, [Cookies.get('user')]);

  const isLaposteEmployee = useMemo(() => {
    return currentUser?.businessId === '1' && currentUser?.businessRoleId === '1';
  }, [currentUser]);

  const resetAllStores = () => {
    dispatch(resetStore());
    dispatch(resetAuthStore());
    dispatch(resetCart());
    dispatch(resetPersistedCart());
    dispatch(resetTravelPurchaseStore());
    dispatch(resetLeisurePurchaseStore());
    navigate(routes.login.path);
  };

  return { isLoggedIn, currentUser, isLaposteEmployee, resetAllStores };
};
